exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TypeaheadInput-default-3RcPf{position:relative}.TypeaheadInput-inputGroup-2I5Nq{overflow:hidden}.TypeaheadInput-result-2QAOK{position:absolute;display:block;top:100%;left:0;right:0;z-index:1000;padding:5px 0;margin:2px 0 0;list-style:none;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.TypeaheadInput-result-2QAOK>li>a{display:block;padding:3px 20px}", ""]);

// exports
exports.locals = {
	"default": "TypeaheadInput-default-3RcPf",
	"inputGroup": "TypeaheadInput-inputGroup-2I5Nq",
	"result": "TypeaheadInput-result-2QAOK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/TypeaheadInput.less
// module id = 1669
// module chunks = 0